export default __webpack_public_path__ + "static/media/IPReservationIcon.5b856ab6.svg";